'use strict';

import template from './template.html';


export default function() {
	return {
		transclude: true,
		replace: true,
		template: template,
	}
}
